// extracted by mini-css-extract-plugin
export default {"platform":"SelfQuizPlatform_platform__hZERY"};